import React, { useEffect, useState } from 'react';
import { LayoutDashboard } from '../../layouts/layout-dashboard';
import { EmotionComponent } from '../../components/emotion-extraction';
import { InvoiceComponent } from '../../components/invoice-extraction';
import { DocumentExtractComponent } from '../../components/document-data-extraction';
import { IntelligentComponent } from '../../components/intelligent-search';

import { Nav } from '../../components/nav';
import { Breadcrumb } from '../../components/breadcrumb';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useAxios } from '../../hooks/useAxios';

const Workflow = (props) => {
  const { data, error, loading, fetchNow } = useAxios();
  const { id } = useParams();
  const [isFetching, setIsFetching] = useState(true);

  const [workflow, setWorkflow] = useState({
    name: null,
    descrption: null,
    workflows: [],
  });
  let componentToLoad;

  useEffect(() => {
    if (loading) return;

    if (isFetching) {
      fetchNow(`/api/platform/workflows/${id}/`, 'GET', null, false);
    }
    const Fetched = () => {
      setWorkflow(data);
      setIsFetching(false);
    };

    Fetched();
  }, [id, fetchNow, data, isFetching, loading]);

  if (id === '10002') {
    // emotion extraction
    componentToLoad = <EmotionComponent></EmotionComponent>;
  } else if (id === '10006') {
    // doc data extraction
    componentToLoad = <DocumentExtractComponent></DocumentExtractComponent>;
  } else if (id === '10011') {
    // intelegent search
    componentToLoad = <IntelligentComponent></IntelligentComponent>;
  } else if (id === '10004') {
    // invoice extraction
    componentToLoad = <InvoiceComponent></InvoiceComponent>;
  } else {
    componentToLoad = (
      <LayoutDashboard>
        <h3>Oops, nothing found here sorry.</h3>
      </LayoutDashboard>
    );
  }

  if (error) {
    console.log('error', error);
    return null;
  }
  return (
    <>
      <div className="dashboard">
        <header>
          <Container fluid>
            <Row>
              <Col lg={8} className="px-5">
                <Breadcrumb label={'Workflow'} />
                <h1>{workflow?.name}</h1>
              </Col>
              <Col lg={4} className="px-5"></Col>
            </Row>
          </Container>
        </header>

        <LayoutDashboard>
          <Row>{workflow?.descrption}</Row>
        </LayoutDashboard>
        {componentToLoad}
        <Nav nav1on="on" nav2on="" nav3on="" {...props} />
      </div>
    </>
  );
};

export { Workflow };
